export enum PAYMENT_STRATEGY {
  FULL,
  IN_FOUR,
}
